import { XSAuthProvider } from '@xinosolutions/xs-auth-react';
import {
  xsAuthClientId,
  xsAuthUrl,
  xsAuthBootstrapUrl,
  xsAccountUrl,
} from '../../config/config';
import { LearnixProductProvider } from '../../contexts/LearnixProductContext';
import ThemeColorAuthSync from './ThemeColorAuthSync';

export default function AuthProviders({ children }) {
  return (
    <XSAuthProvider
      clientId={xsAuthClientId}
      authBaseUrl={xsAuthUrl}
      bootstrapUrl={xsAuthBootstrapUrl}
      accountUrl={xsAccountUrl}
    >
      <ThemeColorAuthSync />
      <LearnixProductProvider>{children}</LearnixProductProvider>
    </XSAuthProvider>
  );
}
